exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.header.inverted {\n  background: #000;\n}\n.header.inverted .logo path {\n  fill: #fff;\n}\n.header.inverted .heart-icon path {\n  fill: #fff;\n}\n.header.inverted .cart-icon path.background {\n  fill: #fff;\n}\n.header.inverted .cart-icon path.outline {\n  fill: #000;\n}\n.header .count {\n  text-align: center;\n  color: #fff;\n  font-size: 12px;\n  width: 100%;\n}\n.header .logo {\n  width: 119px;\n}\n.header .logo path {\n  fill: #100d0c;\n}\n.header path {\n  transition: fill 0.4s ease;\n}", ""]);

// exports
